var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9485 6.85714C16.9485 6.51615 17.084 6.18912 17.3251 5.94801C17.5662 5.70689 17.8932 5.57143 18.2342 5.57143C18.5752 5.57143 18.9023 5.70689 19.1434 5.94801C19.3845 6.18912 19.52 6.51615 19.52 6.85714V16.608C19.5204 17.1849 19.4071 17.7562 19.1865 18.2892C18.9658 18.8222 18.6423 19.3065 18.2342 19.7143C17.8267 20.122 17.3429 20.4454 16.8103 20.666C16.2778 20.8866 15.707 21.0001 15.1305 21H12.6294C11.7827 21.0002 10.949 20.7913 10.2025 20.3919C9.45588 19.9925 8.81945 19.415 8.34967 18.7106L5.2211 14.0177C5.07692 13.801 5 13.5465 5 13.2861C5 13.0258 5.07692 12.7713 5.2211 12.5546V12.5546C5.3226 12.4024 5.45466 12.2729 5.60889 12.1745C5.76311 12.076 5.93613 12.0108 6.11693 11.9828C6.29774 11.9548 6.4824 11.9648 6.65915 12.012C6.83591 12.0592 7.00091 12.1427 7.14367 12.2571L9.23424 13.9294V5.57143C9.23424 5.23044 9.3697 4.90341 9.61082 4.66229C9.85194 4.42117 10.179 4.28571 10.52 4.28571C10.8609 4.28571 11.188 4.42117 11.4291 4.66229C11.6702 4.90341 11.8057 5.23044 11.8057 5.57143V4.28571C11.8057 3.94472 11.9411 3.6177 12.1822 3.37658C12.4234 3.13546 12.7504 3 13.0914 3C13.4324 3 13.7594 3.13546 14.0005 3.37658C14.2416 3.6177 14.3771 3.94472 14.3771 4.28571V5.57143C14.3771 5.23044 14.5126 4.90341 14.7537 4.66229C14.9948 4.42117 15.3218 4.28571 15.6628 4.28571C16.0038 4.28571 16.3308 4.42117 16.572 4.66229C16.8131 4.90341 16.9485 5.23044 16.9485 5.57143V6.85714Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8057 5.56885V10.7117",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3771 5.56885V10.7117",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9485 10.7117V6.85457",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.2e17085bbe0ecbc1666eb1d7d159f309.svg";
export { ForwardRef as ReactComponent };